export default __webpack_public_path__ + "static/media/hrpartner.0f32b536.png";